module.exports = __webpack_public_path__ + "img/shezhi.f511f7c6.png";